import React from 'react';

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import PhoneIcon from '@mui/icons-material/Phone';
import useMediaQuery from '@mui/material/useMediaQuery';
import { colors } from '../../style/colors';

const PhoneContainer = styled('div')({
  paddingTop: '0.25rem',
  display: 'flex',
  alignItems: 'center',
  color: colors.greyDark,
});

const StyledPhoneIcon = styled(PhoneIcon)({
  marginRight: '0.25rem',
});

const PhoneNumberText = styled(Typography)({
  color: colors.blueMuted,
});

export function isValidPhone(number: string): boolean {
  const numRegex = /^[0-9]{10}$/; // 10-digit number
  return numRegex.test(number);
}

export function getDisplayPhone(number: string): string {
  return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6, 10)}`;
}

// Preferred phone format for href: https://developers.google.com/web/fundamentals/native-hardware/click-to-call/?hl=en#other-click-to-call-features
export function getPhoneLink(number: string): string {
  return `tel:+1-${number.slice(0, 3)}-${number.slice(3, 6)}-${number.slice(6, 10)}`;
}

type ParentProps = { number?: string };

export default function PhoneNumber({ number }: ParentProps): JSX.Element {
  const isSmallScreen = useMediaQuery('(max-width: 576px)');
  if (!number) return <div />;
  if (!isValidPhone(number)) return <div />;

  return (
    <PhoneContainer>
      <StyledPhoneIcon fontSize="inherit" />

      {isSmallScreen ? (
        <a
          href={getPhoneLink(number)}
          aria-label="phone number"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none' }}
        >
          <PhoneNumberText variant="body2">{getDisplayPhone(number)}</PhoneNumberText>
        </a>
      ) : (
        <PhoneNumberText variant="body2">{getDisplayPhone(number)}</PhoneNumberText>
      )}
    </PhoneContainer>
  );
}
